import { Loader2 } from 'lucide-react'

import { cn } from '../cn'

export function Skeleton({ className }: { readonly className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        'animate-[shimmer_1.4s_linear_infinite] rounded-sm bg-[linear-gradient(90deg,#e9edf4_0%,#f4f6fa_50%,#e9edf4_100%)] bg-[length:800px_100%]',
        className,
      )}
    />
  )
}

/** A block that mirrors a list page: header line + rows. Announces "Loading" to screen readers. */
export function SkeletonList({
  rows = 5,
  label = 'Loading',
}: {
  readonly rows?: number
  readonly label?: string
}) {
  return (
    <div role="status" aria-label={label} className="space-y-3">
      <Skeleton className="h-5 w-1/3" />
      {Array.from({ length: rows }, (_, i) => (
        <Skeleton key={i} className="h-10 w-full" />
      ))}
    </div>
  )
}

export function Spinner({
  label = 'Loading',
  className,
}: {
  readonly label?: string
  readonly className?: string
}) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex items-center text-muted', className)}
    >
      <Loader2 aria-hidden className="size-4 animate-spin" />
    </span>
  )
}
